import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { OutboundBuddyLogo } from '@/components/brand/OutboundBuddyLogo';

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { user, loading } = useAuth();

  // Allow access during password recovery even if user session exists
  const isPasswordReset = new URLSearchParams(window.location.search).get('reset') === 'true';

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <OutboundBuddyLogo size="lg" />
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (user && !isPasswordReset) {
    // Land on the new UX dashboard. The Auth.tsx useEffect fix
    // (D-001) wasn't enough on its own — PublicRoute intercepts
    // already-authenticated users before Auth.tsx even mounts.
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}